import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import { TEST_ID } from '../../utils/constants';

type TLoginButton = {
  label?: string;
  gtmPayload?: Record<string, string>;
  redirectTo?: string;
}
const LoginButton = ({ label, redirectTo }: TLoginButton) => (
  <Button
    variant="tertiary"
    className="focus:outline-purpleblue"
    onClick={() => window.location.href = redirectTo!}
    data-testid={TEST_ID.BUTTON_SECONDARY}
  >
    {label}
    
  </Button>
);

const Memoized = memo(LoginButton);
Memoized.displayName = 'LoginButton';

export default Memoized;
